var _defs, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgBenefitsEvents = function SvgBenefitsEvents(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 80,
    height: 80
  }, props), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("path", {
    id: "BenefitsEvents_svg__a",
    d: "M33.555 83.725c18.384 0 35.813-15.984 33.951-34.65-.753-7.624-1.983-26.767-3.554-48.84-7.528 4.797-7.488 4.538-10.151 5.952-3.141-2.407-31.134-.533-38.363-.533C-2.947 5.654.259 30.984.259 49.746s14.911 33.98 33.296 33.98"
  }), /*#__PURE__*/React.createElement("path", {
    id: "BenefitsEvents_svg__c",
    d: "M33.51 83.491c18.384 0 35.813-15.984 33.951-34.65C66.71 41.217 65.478 22.074 63.908 0c-7.529 4.798-7.488 4.54-10.152 5.953-3.14-2.407-31.134-.533-38.363-.533C-2.991 5.42.214 30.749.214 49.512s14.912 33.98 33.296 33.98"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0 0h80v80H0z"
  }), /*#__PURE__*/React.createElement("g", {
    transform: "translate(6 -5)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "BenefitsEvents_svg__b",
    fill: "#fff"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#BenefitsEvents_svg__a"
  })), /*#__PURE__*/React.createElement("path", {
    fill: "#BEEBFF",
    d: "M33.555 83.806c18.384 0 35.813-15.976 33.951-34.65-.753-7.616-1.06-11.962-2.623-34.044-7.536 4.806-7.496 4.547-10.151 5.96-3.15-2.422-13.924-5.217-21.177-5.217C15.17 15.855.259 31.072.259 49.835S15.17 83.806 33.555 83.806",
    mask: "url(#BenefitsEvents_svg__b)"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(6.045 -4.766)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "BenefitsEvents_svg__d",
    fill: "#fff"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#BenefitsEvents_svg__c"
  })), /*#__PURE__*/React.createElement("g", {
    mask: "url(#BenefitsEvents_svg__d)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(-5.722 6.825)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#00A1DC",
    fillRule: "nonzero",
    d: "M75.734 75.325c.566-4.846-8.257-18.94-11.236-23.576-7.715-12.043 10.523-8.182 10.523-8.182-.332-.065.502-3.732 6.865 15.475 2.08 6.268 5.108 14.337 4.048 17.915"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#00A1DC",
    fillRule: "nonzero",
    d: "M64.506 79.566c1.295-9.838 1.886-11.51 3.764-20.952 2.485-12.462 7.286-15.346 7.286-15.346l-16.757-7.27s-8.225 9.637-9.23 10.751c-1.003 1.115-1.06-10.637-1.06-10.637s-11.147.525-15.882.808c-4.226.315-5.319 4.192-4.558 7.632.76 3.441 3.4 1.527 3.238 11.526"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#FFB754",
    fillRule: "nonzero",
    d: "m61.68 22.64-2.954 20.192s-4.129 6.025-8.784 5.395c-4.654-.63-1.27-9.652-1.27-9.652s1.877 1.85 6.038-4.418a36 36 0 0 0 5.246-11.445z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#FFB754",
    fillRule: "nonzero",
    d: "M62.66 15.968a3.92 3.92 0 0 1 2.922 1.349 4.03 4.03 0 0 1 .98 3.126c-.138 4.466-5.4 3.95-6.84 2.48.088-1.455 1.173-5.541 2.922-6.939"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#00608B",
    fillRule: "nonzero",
    d: "M49.295 11.518a2.12 2.12 0 0 0-1.838-.808c-.461 0-.89.178-.81.477.082.298.519.525 1.012.59q.596.072 1.19 0c.284 0 .543-.154.454-.34"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#FFB754",
    fillRule: "nonzero",
    d: "M58.013 4.022a18.15 18.15 0 0 0-11.924 6.405l.283 1.406S43.418 16.8 43.49 21.888c.073 5.089 3.174 9.152 1.919 15.904 5.999-.606 11.333-1.18 15.114-14.724l1.619-6.001 2.064-.954s1.62-4.967-.283-9.102a38 38 0 0 0-5.99-2.948"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#FFA100",
    fillRule: "nonzero",
    d: "M57.9 20.693a3.45 3.45 0 0 1-1.32 2.293 3.46 3.46 0 0 1-2.558.687 3.49 3.49 0 0 1-2.93-3.933 3.43 3.43 0 0 1 1.3-2.3 3.45 3.45 0 0 1 2.553-.697 3.507 3.507 0 0 1 2.955 3.95"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#00608B",
    fillRule: "nonzero",
    d: "m61.187 17.98.89-.364 2.21-1.22 1.198.808-.146-1.333 1.126.073-.94-3.376 1.676 1.26s-1.57-4.96-3.238-6.882S55.512 0 55.512 0l-2.259 2.9 9.553 4.24 1.254 3.126-2.582 2.778-1.19 3.82z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#EE8500",
    fillRule: "nonzero",
    d: "M50.12 13.319s-4.703 6.728-4.193 7.891 2.85 1.43 3.125 1.01c1.093-1.575 1.068-8.885 1.068-8.885"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#003449",
    fillRule: "nonzero",
    d: "M53.577 15.144a.971.971 0 0 1-1.888-.09.965.965 0 0 1 1.58-.91.99.99 0 0 1 .308 1M48.43 13.53a.98.98 0 0 1-.721.808.94.94 0 0 1-1.012-.396.99.99 0 0 1-.057-1.09.96.96 0 0 1 .972-.47.98.98 0 0 1 .81 1.107"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#00608B",
    fillRule: "nonzero",
    d: "M52.37 12.713c.364.59.999.96 1.693.985.461 0 .906-.056.866-.355a1 1 0 0 0-.866-.678 4.8 4.8 0 0 0-1.166-.186c-.3 0-.575.089-.502.274zm7.918 4.152-1.182 2.64s-7.658 4.209-10.289 3.958-5.318-2.48-5.318-2.48l-.413.695s.404 3.037.81 5.654c.404 2.617 2.112 9.652 1.213 12.988a17.13 17.13 0 0 0 12.734-9.692 50 50 0 0 0 3.773-12.923z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#FFB754",
    fillRule: "nonzero",
    d: "M44.43 25.895c.267 1.882 1.198 3.57 3.505 2.818 2.307-.75.81-1.817-3.506-2.818"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#003449",
    fillRule: "nonzero",
    d: "M48.874 27.938a.45.45 0 0 1-.227-.105c-1.27-1.22-3.918-1.325-3.942-1.325a.428.428 0 0 1 0-.807c.121 0 2.97.113 4.476 1.55.08.077.123.182.122.291a.4.4 0 0 1-.122.3.4.4 0 0 1-.348.128"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#00A1DC",
    fillRule: "nonzero",
    d: "M30.352 37.59c-2.064-.937-23.663 22.963-23.663 22.963s-9.916 8.61-5.601 11.477c6.581 4.394 32.77 5.234 32.77 5.234l3.804-10.306-18.53-1.438 13.26-12.527z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#EE8500",
    fillRule: "nonzero",
    d: "M30.449 80.406a14.97 14.97 0 0 1-1.368-10.597 12.56 12.56 0 0 0-3.772-12.116 9.7 9.7 0 0 1-1.822-2.31c-4.412-7.753-.858-12.761 5.181-16.646L18.249 18.6l-.17.105a1.85 1.85 0 0 0-2.485-.727L9.49 8.53a8.98 8.98 0 0 1 8.023-4.668l4.857 10.274a1.93 1.93 0 0 0-.696 2.528h-.057L33.64 35.99c6.2-2.916 11.94-3.053 16.247 4.604.468.875.824 1.806 1.06 2.77.952 4.414 4.168 8 8.46 9.434a14.74 14.74 0 0 1 8.419 6.615"
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 38.658,
    cy: 50.804,
    fill: "#00A4E0",
    fillRule: "nonzero",
    rx: 5.383,
    ry: 5.492
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#00A4E0",
    d: "M50.946 71.117 16.072 11.073l-.373.243L50.574 71.36z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#008BCA",
    fillRule: "nonzero",
    d: "m36.958 67.127 13.43 5.081 13.421 5.024"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#FFB754",
    fillRule: "nonzero",
    d: "M34.901 75.398s5.133-.993 8.217-.743 9.892.396 9.034-1.163.81-3.409-.502-4.967c-1.311-1.56-7.722-6.187-9.673-4.847-1.951 1.341-11.471 8.344-11.471 8.344z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#00A1DC",
    fillRule: "nonzero",
    d: "M19.132 65.52 2.56 72.49c9.714 2.73 32.98 6.187 32.98 6.187l2.12-11.72z"
  })))), /*#__PURE__*/React.createElement("path", {
    fill: "#00A4E0",
    fillRule: "nonzero",
    d: "M37.227 15.687c.194-2.906.454-5.772.665-8.71.462.36.948.704 1.443 1.016l.738.446c.648.382 1.28.718 1.962 1.109q.205.13.438.203c.243.062.268-.242.292-.555.08-1.086.162-2.03.235-3.124 0-.281 0-.39-.195-.555l-1.857-1.234a16 16 0 0 1-1.905-1.5l-1.825-1.648c-.332-.258-.567-.14-.6.297a458 458 0 0 1-.235 3.304l-.81 10.256a5.6 5.6 0 0 0-3.244-1.297c-2.765-.203-5.15 1.484-5.32 3.765s1.947 4.304 4.704 4.5c1.728.217 3.449-.45 4.54-1.758.9-1.219.925-3.312 1.006-4.515zM14.41 40.623c-.824-2.02-1.78-4.013-2.678-6.041-.214.382-.453.755-.7 1.12l-.379.517c-.338.45-.675.849-1.03 1.34q-.103.144-.238.255c-.149.11-.24-.101-.33-.305-.346-.772-.65-1.408-.98-2.172-.083-.195-.116-.28 0-.45l.914-1.374q.506-.77.89-1.612l.824-1.697c.156-.28.337-.263.478 0l1.005 2.299 3.18 7.11a4.17 4.17 0 0 1 1.853-1.816c1.804-.907 3.831-.347 4.54 1.23.708 1.579-.198 3.615-1.994 4.506a3.47 3.47 0 0 1-3.477 0c-.947-.594-1.5-2.07-1.878-2.91"
  }))));
};
export default SvgBenefitsEvents;